var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C4.58172 17 1 13.4182 1 9C1 4.58172 4.58172 1 9 1C13.4182 1 17 4.58172 17 9C17 13.4182 13.4182 17 9 17Z",
    stroke: "#1E7C88",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.599 11C12.599 11 11.399 12.6 8.99902 12.6C6.59902 12.6 5.39902 11 5.39902 11",
    stroke: "#1E7C88",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8002 6.5998C11.5794 6.5998 11.4002 6.42072 11.4002 6.1998C11.4002 5.97889 11.5794 5.7998 11.8002 5.7998C12.0211 5.7998 12.2002 5.97889 12.2002 6.1998C12.2002 6.42072 12.0211 6.5998 11.8002 6.5998Z",
    fill: "#1E7C88",
    stroke: "#1E7C88",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20035 6.5998C5.97944 6.5998 5.80035 6.42072 5.80035 6.1998C5.80035 5.97889 5.97944 5.7998 6.20035 5.7998C6.42127 5.7998 6.60035 5.97889 6.60035 6.1998C6.60035 6.42072 6.42127 6.5998 6.20035 6.5998Z",
    fill: "#1E7C88",
    stroke: "#1E7C88",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiicon);
export default __webpack_public_path__ + "static/media/emojiicon.2030f815bacec6ba64ee1af09d37d24f.svg";
export { ForwardRef as ReactComponent };